import React, { useEffect, useState } from 'react';
import { Button, Card, CardHeader, CardBody, Table } from 'reactstrap';
import api from '../services/api';
import NewServicePricingModal from './NewServicePricingModal';
import EditServicePricingModal from './EditServicePricingModal';
import Layout from './Layout';

const ServicePricing = () => {
    const [servicePricings, setServicePricings] = useState([]);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [editingPricingTier, setEditingPricingTier] = useState(null);
    const [timeframes, setTimeframes] = useState([]);
    const [pricingTiersList, setPricingTiersList] = useState([]);
    const [services, setServices] = useState([]);

    const fetchServicePricings = async () => {
        try {
            const response = await api.get('/service-pricing/');
            setServicePricings(response.data);
        } catch (error) {
            console.error('Error fetching service pricings:', error);
        }
    };

    useEffect(() => {
        const fetchTimeframes = async () => {
            try {
                const response = await api.get('/timeframes/');
                setTimeframes(response.data);
            } catch (error) {
                console.error('Error fetching timeframes:', error);
            }
        };

        const fetchPricingTiers = async () => {
            try {
                const response = await api.get('/pricing-tiers/');
                setPricingTiersList(response.data);
            } catch (error) {
                console.error('Error fetching pricing tiers:', error);
            }
        };

        const fetchServices = async () => {
            try {
                const response = await api.get('/services/');
                setServices(response.data);
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        };

        fetchServicePricings();
        fetchTimeframes();
        fetchPricingTiers();
        fetchServices();
    }, []);

    const openAddModal = () => {
        setAddModal(true);
    };

    const closeAddModal = () => {
        setAddModal(false);
    };

    const addNewPricing = async (newPricing) => {
        try {
            await api.post('/service-pricing/', newPricing);
            await fetchServicePricings();
            closeAddModal();
        } catch (error) {
            console.error('Error adding service pricing:', error);
        }
    };

    const openEditModal = async (pricing) => {
        setEditingPricingTier(pricing);
        setEditModal(true);
    };

    const closeEditModal = () => {
        setEditModal(false);
    };

    const saveEditedPricing = async () => {
        await fetchServicePricings();
        closeEditModal();
    };

    return (
        <Layout>
            <Card>
                <CardHeader tag="h3">Service Pricing</CardHeader>
                <CardBody>
                    <Table striped hover bordered responsive>
                        <thead>
                            <tr>
                                <th>Timeframe</th>
                                <th>Pricing Tier</th>
                                <th>Service</th>
                                <th>Base Price</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {servicePricings.map(pricing => (
                                <tr key={pricing.id}>
                                    <td>{timeframes.find(tf => tf.id === pricing.timeframe)?.name || 'N/A'}</td>
                                    <td>{pricingTiersList.find(pt => pt.id === pricing.pricing_tier)?.name || 'N/A'}</td>
                                    <td>{services.find(s => s.id === pricing.service)?.title}</td>
                                    <td>${pricing.base_price}</td>
                                    <td>
                                        <Button color="primary" onClick={() => openEditModal(pricing)}>
                                            Edit
                                        </Button>{' '}
                                        <Button color="danger" onClick={async () => {
                                            try {
                                                await api.delete(`/service-pricing/${pricing.id}`);
                                                setServicePricings(servicePricings.filter(p => p.id !== pricing.id));
                                            } catch (error) {
                                                console.error('Error deleting service pricing:', error);
                                            }
                                        }}>
                                            Delete
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <Button color="primary" onClick={openAddModal}>Add Service Pricing</Button>

                    <NewServicePricingModal
                        isOpen={addModal}
                        toggle={closeAddModal}
                        onAdd={addNewPricing}
                        timeframes={timeframes}
                        pricingTiers={pricingTiersList}
                        services={services}
                    />

                    {editingPricingTier && (
                        <EditServicePricingModal
                            isOpen={editModal}
                            toggle={closeEditModal}
                            pricing={editingPricingTier}
                            onSave={saveEditedPricing}
                            timeframes={timeframes}
                            pricingTiers={pricingTiersList}
                            services={services}
                        />
                    )}
                </CardBody>
            </Card>
        </Layout>
    );
};

export default ServicePricing;
